import { readBenchmarkError } from "./reportData"

const DEFAULT_BENCHMARK_API_URL = "https://api-shock-marketing.fractolabs.com"

export function benchmarkApiUrl() {
  const configured = process.env.REACT_APP_BENCHMARK_API_URL || DEFAULT_BENCHMARK_API_URL
  return String(configured).replace(/\/$/, "")
}

async function request(path, { method = "GET", body, signal } = {}) {
  const headers = {}
  const init = { method, headers, signal }
  if (body !== undefined) {
    headers["Content-Type"] = "application/json"
    init.body = JSON.stringify(body)
  }

  let response
  try {
    response = await fetch(`${benchmarkApiUrl()}${path}`, init)
  } catch (error) {
    if (error?.name === "AbortError") throw error
    throw new Error(readBenchmarkError(null))
  }

  if (!response.ok) {
    let payload = null
    try {
      payload = await response.json()
    } catch {
      payload = null
    }
    throw new Error(readBenchmarkError(payload))
  }

  return response.json()
}

export function getSearchSettings(signal) {
  return request("/api/leads/search-settings", { signal })
}

export function getResponseStats(campaignIds, signal) {
  return request("/api/campaigns/response-stats", {
    method: "POST",
    body: { campaign_ids: campaignIds },
    signal,
  })
}

export function searchLeads(body, signal) {
  return request("/api/leads/search", {
    method: "POST",
    body,
    signal,
  })
}
